export const colors = {
  primary: "#36278A",
};